<template>
  <div class="right-side-drawer">
    <transition name="fade">
      <div v-if="$props.visible" ref="backdrop" class="backdrop" @click="handleBackdropClick"></div>
    </transition>
    <transition name="right-drawer" mode="out-in">
      <div class="drawer-content" v-if="$props.visible">
        <slot></slot>
      </div>
    </transition>
    <transition name="right-drawer" mode="out-in">
      <slot name="details"></slot>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'right-side-drawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleBackdropClick () {
      this.$emit('backdrop-click')
    }
  }
}
</script>

<style scoped lang="scss">
.right-side-drawer {
  .backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    z-index: map-get($z-index, sidebar);
  }

  .drawer-content {
    position: fixed;
    top: 5.5rem;
    left: auto;
    right: 0;
    width: auto;
    height: 100%;
    will-change: transform;
    z-index: map-get($z-index, rightDrawer);

    @media (map_get($breakpoints, sm)) {
      top: 6rem;
    }

    @media (map_get($breakpoints, lg)) {
      top: 6.8rem;
    }

    @media (map_get($breakpoints, xxl)) {
      top: 8.8rem;
    }
  }
}
</style>
